module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mkUg80/tc-custom/9781625847676.jpg?1705026122838",
      "alt": "This image is the cover for the book On This Day in Outer Banks History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("On This Day in Outer Banks History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Outer Banks is much more than an idyllic vacation destination. A day at a time through history, it has claimed its place as a colorful region of the Old North State. Author and historian Sarah Downing offers a daily look at the quirky and fascinating stories from the region's four-hundred-year history. During a fierce hand-to-hand battle off Ocracoke Island on November 22, 1718, Lieutenant Robert Maynard killed the infamous pirate Blackbeard with five pistol shots and twenty sword cuts and slashes. On February 14, 1992, a sick seal caught a ride to safety on a Coast Guard patrol boat. Add a salty slice of history a day or a month at time with this celebration of Outer Banks heritage.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Downing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sarah Downing has been an involved resident of the Outer Banks community for over 20 years.  She is an Assistant Curator at the Outer Banks History Center and has published multiple books and articles as a freelance writer since 2005.  Besides working at the History Center, Sarah does a short radio segment each week and enjoys residing in Nags Head.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0